import React from 'react'

import RecordHeading from '../../../ui/record-heading'
import RecordDisplay from '../../../ui/record-display'
import GovMessages from '../../../ui/gov-messages'

import ServiceList from '../../service-list'
import PersonnelList from '../../personnel-list'
import B2BDeviceList from '../../b2b-device-list'

const serviceAddress = ({ Address }) =>
  [
    Address.results[0].streetLine1,
    Address.results[0].suburb,
    Address.results[0].postcode,
    Address.results[0].state,
  ]
    .filter(val => val)
    .join('\u000A')

const levelOneRecordFieldsDiRecordDisplay = [
  {
    key: 'providerID',
    label: 'Provider ID',
  },
  {
    label: 'Address',
    fn: serviceAddress,
  },
  {
    key: 'CCSApproval.results.0.status',
    label: 'CCS Approval Status',
  },
  {
    key: 'CCSApproval.results.0.startDate',
    label: 'CCS Approval Start Date',
  },
]

const levelTwoRecordsFieldsDiRecordDisplay = [
  {
    key: 'providerEntityType',
    label: 'Provider Entity Type',
  },
]

const formatGovRecordName = ({ ProviderName }) => ({ first_name: ProviderName.results[0].name })

const ProviderCCSRegistration = ({ record = {} }) => {
  return (
    <div className="ProviderCCSRegistration">
      <RecordHeading record={formatGovRecordName(record.gov_record)} />
      <RecordDisplay
        record={record.gov_record}
        level1={levelOneRecordFieldsDiRecordDisplay}
        level2={levelTwoRecordsFieldsDiRecordDisplay}
        showRaw
      />
      <GovMessages record_type="provider-registrations" record_id={record.gov_id} />
      <B2BDeviceList provider_registration_id={record.gov_id} />
      <PersonnelList
        provider_registration_id={record.gov_id}
        available_actions={record.available_actions}
        provider_id={record.provider_id}
      />
      <ServiceList provider_registration_id={record.gov_id} />
    </div>
  )
}

export default ProviderCCSRegistration



// WEBPACK FOOTER //
// ./src/providers-registrations/details/views/index.jsx